import { combineReducers } from 'redux';

import authReducer from './auth.reducer';
import downloadsReducer from './downloads.reducer';
import subscriptionReducer from './subscription.reducer';
import menuReducer from './menu.reducer';
import categoriesReducer from './categories.reducer';
import categoryArticlesReducer from './category-articles.reducer';
import documentReducer from './document.reducer';

const rootReducer = combineReducers({
    auth: authReducer,
    downloads: downloadsReducer,
    subscription: subscriptionReducer,
    categories: categoriesReducer,
    categoryArticles: categoryArticlesReducer,
    mobileMenuOpen: menuReducer,
    embeddedDocs: documentReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts